
if (!customElements.get('cart-location-select')) {

  class CartLocationSelect extends HTMLElement {
    constructor() {
      super();

      this.cartDrawerForm = document.getElementById(this.getAttribute("form"));
      this.cartDrawerSubmitButton = document.querySelector(this.getAttribute("button-selector"));

      this.locationSelect = this.querySelector('.js-location-select');
      this.locationSelect.addEventListener('change', this.handleLocationChange.bind(this));
    }

    /**
     * Handles the change event on the location select.
     * @param {object} evt - Event object.
     */
    async handleLocationChange(evt) {
      const location = evt.target.value;
      const currentButtonHTML = this.cartDrawerSubmitButton.innerHTML;

      // set loading state
      this.cartDrawerSubmitButton.setAttribute('disabled', 'disabled');
      this.cartDrawerSubmitButton.innerHTML = "Cargando...";

      // change action to apply cart permalink
      const url = new URL(this.cartDrawerForm.action);
      url.searchParams.set('checkout[shipping_address][city]', location);
      this.cartDrawerForm.action = url.toString();

      const response = await fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'shipping_sector': location
          }
        })
      });

      if (response.ok) {
        // dispatch to other plugins
        this.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));

        // ensure thje button status
        if (location !== "") {
          this.cartDrawerSubmitButton.removeAttribute('disabled');
        }
      }

      this.cartDrawerSubmitButton.innerHTML = currentButtonHTML
    }

  }

  customElements.define('cart-location-select', CartLocationSelect);

}
